import React, { useState } from 'react';
import { X } from 'lucide-react';

const PartnerGallery = ({ images, name }) => {
  const [open, setOpen] = useState(null);
  if (!images.length) return null;

  return (
    <section className="mb-14" data-testid="partner-gallery">
      <p className="text-[10px] tracking-[0.3em] uppercase mb-3" style={{ color: '#DE92A9' }}>Gallery</p>
      <h2 className="text-2xl md:text-3xl mb-6" style={{ fontFamily: '"Playfair Display", serif', color: '#2C2C2C' }}>
        {name} in pictures
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {images.map((src, i) => (
          <button
            key={src}
            type="button"
            onClick={() => setOpen(src)}
            className={`group relative overflow-hidden rounded-xl bg-[#F3ECEF] ${i === 0 ? 'col-span-2 row-span-2 aspect-[4/3]' : 'aspect-square'}`}
            data-testid={`partner-gallery-image-${i}`}
          >
            <img
              src={src}
              alt={`${name} wedding ${i + 1}`}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
          </button>
        ))}
      </div>

      {open && (
        <div
          className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4"
          onClick={() => setOpen(null)}
          data-testid="partner-gallery-lightbox"
        >
          <button type="button" aria-label="Close" className="absolute top-5 right-5 text-white/80 hover:text-white" data-testid="partner-gallery-close">
            <X size={28} />
          </button>
          <img src={open} alt={name} className="max-w-full max-h-[90vh] rounded-lg shadow-2xl" />
        </div>
      )}
    </section>
  );
};

export default PartnerGallery;
